module.exports = __webpack_public_path__ + "img/Frame 11@2x.80d256b0.png";